export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精心策划的漫画专题合集，发现不同主题下的优质作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20spring%20romance%20manga%20theme%20with%20cherry%20blossoms%20and%20soft%20pastel%20colors%2C%20romantic%20couple%20silhouette%20against%20sunset%2C%20dreamy%20atmosphere%2C%20manga%20banner%20style%2C%20clean%20composition%2C%20Japanese%20anime%20aesthetic&width=1600&height=700&seq=carousel-01&orientation=landscape"
              alt="春日恋爱特辑"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50 mb-2">恋爱</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">春日恋爱特辑</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">精选八部甜蜜恋爱漫画，感受樱花树下的浪漫邂逅与心动瞬间</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20banner%20illustration%20with%20dragons%20and%20magical%20landscapes%2C%20warm%20golden%20and%20coral%20colors%2C%20grand%20adventure%20atmosphere%2C%20heroic%20characters%20facing%20epic%20destiny%2C%20fantasy%20world%20theme%2C%20clean%20composition&width=1600&height=700&seq=carousel-02&orientation=landscape"
              alt="奇幻冒险盛宴"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-500 text-[10px] font-medium text-background-50 mb-2">奇幻</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">奇幻冒险盛宴</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">穿越异世界展开史诗冒险，剑与魔法的奇幻旅程等你来体验</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Mystery%20suspense%20manga%20banner%20with%20dark%20alley%20and%20silhouette%20figures%2C%20film%20noir%20atmosphere%2C%20warm%20amber%20lighting%20against%20shadows%2C%20detective%20theme%2C%20thriller%20aesthetic%2C%20clean%20cinematic%20composition&width=1600&height=700&seq=carousel-03&orientation=landscape"
              alt="悬疑烧脑精选"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500 text-[10px] font-medium text-background-50 mb-2">悬疑</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">悬疑烧脑精选</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">层层反转的悬疑漫画，每一页都暗藏玄机，挑战你的推理能力</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Sports%20manga%20banner%20with%20dynamic%20volleyball%20match%20scene%2C%20energetic%20action%20composition%2C%20warm%20coral%20and%20white%20colors%2C%20team%20spirit%20theme%2C%20passionate%20atmosphere%2C%20manga%20banner%20style&width=1600&height=700&seq=carousel-04&orientation=landscape"
              alt="热血运动专场"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500 text-[10px] font-medium text-background-50 mb-2">热血</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">热血运动专场</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">汗水与梦想交织，排球场上燃烧的青春，感受运动漫画的激情与感动</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20ancient%20style%20manga%20banner%20with%20traditional%20architecture%20and%20flowing%20hanfu%20characters%2C%20ink%20wash%20painting%20style%2C%20elegant%20warm%20earth%20tones%2C%20historical%20fantasy%20theme%2C%20refined%20aesthetic%20composition&width=1600&height=700&seq=carousel-05&orientation=landscape"
              alt="古风雅韵合集"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-500 text-[10px] font-medium text-background-50 mb-2">古风</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">古风雅韵合集</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">水墨丹青间的国风漫画，穿越千年感受古人世界的爱恨情仇</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[240px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Slice%20of%20life%20manga%20banner%20with%20cozy%20cafe%20and%20warm%20lighting%2C%20gentle%20everyday%20scenes%2C%20soft%20cream%20and%20mint%20color%20palette%2C%20relaxing%20atmosphere%2C%20healing%20theme%2C%20manga%20banner%20aesthetic&width=1600&height=700&seq=carousel-06&orientation=landscape"
              alt="治愈日常系"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500 text-[10px] font-medium text-background-50 mb-2">治愈</span>
              <h3 className="text-base font-heading font-bold text-background-50 mb-1">治愈日常系</h3>
              <p className="text-xs text-background-50/80 line-clamp-2">温馨治愈的日常漫画，用温柔的笔触描绘平凡生活里的点滴美好</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}